// Count one GoatCounter page view per URL the visitor lands on.
//
// count.js is loaded with no_onload, because the live pages refresh themselves with Turbo
// morphs of the same URL on every Action Cable broadcast. Each morph fires turbo:load, and
// without this guard every refresh would count as a page view. The script tag is present
// only when GOATCOUNTER_URL is set, so nothing runs in development.
let countedPath = null

function count() {
  const path = window.location.pathname + window.location.search
  if (path === countedPath) return

  countedPath = path
  window.goatcounter.count({ path })
}

export default function countPageViews() {
  document.addEventListener('turbo:load', () => {
    const script = document.querySelector('script[data-goatcounter]')
    if (!script) return

    if (window.goatcounter && window.goatcounter.count) {
      count()
    } else {
      script.addEventListener('load', count, { once: true })
    }
  })
}
